<template>
  <base-layout toolbarActive>
    <template #toolbarBase>
      <router-link :to="{ name: 'polls' }" class="link text-xs-center">
        <span class="valign-middle font-weight-medium" v-if="!mobile">
          <icon-arrow class="mr-2"></icon-arrow>
          К списку опросов
        </span>
        <span
          class="valign-middle font-weight-bold display-2 pb-0 text--secondary adv-date"
          v-if="mobile && item.id"
        >
          Редактирование опроса
        </span>
        <span
          class="valign-middle font-weight-bold display-2 pb-0 text--secondary adv-date"
          v-if="mobile && !item.id"
        >
          Добавление опроса
        </span>
      </router-link>
    </template>

    <v-container fluid grid-list-xl>
      <hint-widget
        hintName="pollsSettings"
        type="text"
        class="mb-4 ml-3"
        btnMore
      ></hint-widget>
    </v-container>

    <v-container fluid grid-list-xl pt-0>
      <v-layout v-if="isLoaded">
        <v-flex
          v-if="!['xs'].includes($vuetify.breakpoint.name)"
          :class="{ 'layout align-center justify-center ma-0': screenLoading }"
          xl3
          lg4
          md5
        >
          <poll-preview
            v-if="!screenLoading"
            @openDialog="$emit('openDialog', $event)"
            :item="item"
            type="sm"
            page="poll"
          ></poll-preview>

          <v-progress-circular
            v-if="screenLoading"
            :size="50"
            :width="2"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-flex>
        <v-flex
          xl9
          lg8
          md7
          class="d-flex justify-center pb-0"
          :class="{
            'content-bg--1': !['xs'].includes($vuetify.breakpoint.name)
          }"
        >
          <div class="flex xl10 pt-0 pb-5 pt-sm-5">
            <poll-settings
              @openDialog="$emit('openDialog', $event)"
              @save="save"
              @deleteAnswer="deleteAnswer"
              @addHotspot="addHotspot"
              @deleteHotspot="deleteHotspot"
              :poll="item"
            ></poll-settings>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-btn block @click="save" class="primary tile btn-fixed hidden-sm-and-up">
      Сохранить
    </v-btn>
  </base-layout>
</template>
<script>
import BaseLayout from "../components/layout/BaseLayout.vue";
import IconArrow from "../components/icon/IconArrow.vue";
import PollSettings from "../components/polls/PollSettings.vue";
import PollPreview from "../components/polls/PollPreview.vue";
import HintWidget from "../components/common/HintWidget.vue";

export default {
  name: "PollSettingsView",

  components: {
    PollSettings,
    PollPreview,
    IconArrow,
    BaseLayout,
    HintWidget
  },

  data: () => ({
    screenLoading: false
  }),
  mounted() {
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad");
    // загружаем список опросов
    this.$store.dispatch("pollListLoad");
  },
  computed: {
    id: {
      get() {
        return this.$route.params.id ? parseInt(this.$route.params.id) : "";
      },
      set(val) {
        return val;
      }
    },
    isLoaded() {
      if (!this.id) {
        return true;
      } else if (this.$store.getters.pollIsLoaded) {
        return true;
      }
      return false;
    },
    item() {
      let item = { ...this.$store.getters.pollDefaultParams };
      if (this.id && this.isLoaded) item = this.$store.getters.getPoll(this.id);
      return item;
    },
    mobile() {
      return ["xs", "sm"].includes(this.$vuetify.breakpoint.name);
    }
  },
  methods: {
    /**
     * Сохранение формы в базе
     * @param params - параметры формы
     */
    save(params) {
      if (params.poll.id) this.edit(params);
      else this.create(params);
    },
    /**
     * Cоздание нового опроса
     */
    create(params) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("createPoll", params)
          .then(data => {
            this.id = data.id;
            this.$router.push({
              name: "pollSettings",
              params: { id: data.id }
            });
            this.$store.dispatch("popupInfoOpen", {
              text: "Опрос успешно добавлен"
            });
            this.setScreenshote(["poll"]);
            resolve();
          })
          .catch(reject);
      });
    },
    /**
     * Редактирование опроса
     */
    edit(params) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("editPoll", params)
          .then(() => {
            this.$store.dispatch("popupInfoOpen", {
              text: "Опрос успешно изменен"
            });
            this.setScreenshote(["poll"]);
            resolve();
          })
          .catch(reject);
      });
    },
    /**
     * Удаление ответа
     */
    deleteAnswer(params) {
      this.$store.dispatch("deleteAnswerPoll", { id: params.id }).then(() => {
        this.$store.dispatch("popupInfoOpen", {
          text: "Вариант ответа успешно удален",
          timeout: 180000,
          action: {
            name: "Восстановить",
            method: "recoveryAnswerPoll",
            textThen: "Вариант ответа успешно восстановлен",
            param: { id: params.id }
          }
        });
        // обновляем скриншоты через 5 секунд если вдруг будет восстановлние
        setTimeout(() => {
          this.setScreenshote(["poll"]);
        }, 3600);
      });
    },
    /**
     * Получение скриншотов для preview
     */
    setScreenshote(pages) {
      const item = { ...this.item };
      this.screenLoading = true;

      // получает скриншоты для ПК и мобильной версии и сохраняет
      Promise.all(
        ["xs", "xl"].map(size => {
          return new Promise((resolve, reject) => {
            this.$store
              .dispatch("setWifiAuthScreenshotes", {
                pages: pages,
                size: size,
                poll_id: item.id
              })
              .then(resolve)
              .catch(reject);
          });
        })
      )
        .then(values => {
          let items = {};
          values.forEach(value => {
            items = { ...items, ...value };
          });
          item.params.preview = { ...item.params.preview, ...items };
          this.$store.dispatch("editPoll", { poll: item }).then(() => {
            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: "Скриншоты обновлены"
            });
            this.screenLoading = false;
          });
        })
        .catch(() => {
          // открываем сообщение
          this.$store.dispatch("popupInfoOpen", {
            text: "Ошибка при обновлении скриншотов",
            type: "error"
          });
          this.screenLoading = false;
        });
    },
    /**
     * Редактирование у хотспота поля с опросом
     */
    editHotspotPoll(hotspot_id, message, deleted) {
      let params = {
        ...this.$store.getters.hotspotList.find(item => item.id === hotspot_id),
        poll_id: this.item.id,
        deleted: deleted ? true : false
      };
      this.$store
        .dispatch("pinHotspot", params)
        .then(() => {
          // открываем сообщение
          this.$store.dispatch("popupInfoOpen", {
            text: message
          });
        })
        .catch();
    },
    /**
     * Прикрепление опроса к хотспоту
     */
    addHotspot(params) {
      if (this.item.id)
        this.editHotspotPoll(
          params.hotspot_id,
          "Опрос успешно прикреплен к хотспоту"
        );
      else
        this.create({ poll: params.poll, answers: params.answers }).then(() => {
          this.editHotspotPoll(
            params.hotspot_id,
            "Опрос успешно прикреплен к хотспоту"
          );
        });
    },
    // Откпреление опроса от хотспота
    deleteHotspot(hotspot_id) {
      this.editHotspotPoll(
        hotspot_id,
        "Опрос успешно откреплен от хотспота",
        true
      );
    }
  }
};
</script>
